import Config from '../../config';
import fetch from '../../utils/fetchService';
import { handleErrors, parseAsJson } from '../../utils/requestHelpers';

export const fetchScenarios = () => fetch(
  Config.endpoints.FETCH_SCENARIOS
)
  .then(handleErrors({ errorMessage: 'Fetching scenarios failed' }))
  .then(parseAsJson);

export const checkIfScenarioNameExists = ({ scenarioName, excludeScenarioId }) => fetch(
  Config.endpoints.CHECK_IF_SCENARIO_NAME_EXISTS
    .replace(/:scenarioName/, scenarioName)
    .replace(/:excludeScenarioId/, excludeScenarioId ? excludeScenarioId : ''),
  {
    method: 'GET',
  }
)
  .then(handleErrors({ errorMessage: 'Validating scenario name failed' }))
  .then(parseAsJson);

export const createScenario = scenario => fetch(
  Config.endpoints.CREATE_SCENARIO,
  {
    method: 'POST',
    body: JSON.stringify(scenario),
  }
)
  .then(handleErrors({ errorMessage: 'Creating scenario failed' }));

export const updateScenario = scenario => fetch(
  Config.endpoints.UPDATE_SCENARIO
    .replace(/:scenarioId/, scenario.scenarioId),
  {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      publicFlag: scenario.publicFlag,
    }),
  }
)
  .then(handleErrors({ errorMessage: 'Saving scenario failed' }));


export const removeScenario = scenario => fetch(
  Config.endpoints.REMOVE_SCENARIO
    .replace(/:scenarioId/, scenario.scenarioId),
  {
    method: 'DELETE',
  }
)
  .then(handleErrors({ errorMessage: 'Removing scenario failed' }));
